import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import store from '../state'
import routes from './routes'
import { cosh } from 'core-js/fn/number'

Vue.use(Router)
Vue.use(Meta)

Vue.use(Router)

const router = new Router({
    routes,
    base: process.env.BASE_URL,
    mode: 'history',
    scrollBehavior: function(to) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
    }
})

router.beforeEach((to, from, next) => {
    function redirectToLogin() {
        next({ name: 'login', query: { redirectFrom: to.fullPath } })
    }

    function directToLogin() {
        next({ name: 'login' })
    }

    function redirectToForbidden() {
        next({ path: '/forbidden', query: { redirectFrom: to.fullPath } })
    }

    if (to.fullPath.indexOf('recovery_token') !== -1 && to.name !== 'login') {
        return redirectToLogin()
    }

    const authRequired = to.matched.some((route) => route.meta.authRequired)

    if (!authRequired) return next()

    if (store.getters['auth/adminLoggedIn']) {
        return store.dispatch('auth/validate').then((validUser) => {
            if (!validUser) redirectToLogin()

            const rankRequired = to.matched.find((route) => route.meta.rankRequired)

            if (!rankRequired) return next()

            const userRanks = store.getters['auth/ranks']

            if (!userRanks) return redirectToForbidden()

            const rankMatched = userRanks.indexOf(rankRequired.meta.rankRequired) !== -1

            if (rankMatched) return next()

            redirectToForbidden()
        })
    }

    if (store.getters['auth/loggedIn'] && !store.getters['auth/admin']) {
        return next({ name: 'awaiting approval' })
    }

    if (to.fullPath === '/login') {
        return directToLogin()
    }

    redirectToLogin()
})

export default router
